// extracted by mini-css-extract-plugin
module.exports = {"icone":"HamburgerIcone_icone__eqdm3"};